import { render } from "./RecycleStatusDialog.vue?vue&type=template&id=6c954352&scoped=true"
import script from "./RecycleStatusDialog.vue?vue&type=script&lang=js"
export * from "./RecycleStatusDialog.vue?vue&type=script&lang=js"

import "./RecycleStatusDialog.vue?vue&type=style&index=0&id=6c954352&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c954352"]])

export default __exports__